export const initialState = {
    projects: [],
    project: {
        archived: false,
        assetaccounts: [],
        basecurrency: null,
        cashaccounts: [],
        clients: [],
        currencies: [],
        exchangerates: [],
        expenseaccounts: [],
        expensegroups: [],
        equityaccounts: [],
        incomeaccounts: [],
        incomegroups: [],
        interaccounttransfers: [],
        items: [],
        itemscategories: [],
        itemsmodifiers: [],
        journalentries: [],
        name: '',
        lastmodified: 0,
        liabilityaccounts: [],
        pos: {
            type: '',
            tables: [
                { id: '', name: '', px: 0, py: 0 }
            ],
            margin: 30
        },
        projectdetails: null,
        projectdetailsimage: null,
        projectid: null,
        projectuserid: null,
        purchaseinvoices: [],
        productionorders: [],
        reconciliations: [],
        quotations: [],
        salesinvoices: [],
        size: '',
        startdate: '',
        subaccounts: [],
        suppliers: [],
        taxes: [],
        transactions: [],
        users: []
    },
}

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_PROJECTS":
            return {
                ...state,
                mode: action.mode,
                projects: action.projects
            }
        case "SET_PROJECT":
            return {
                ...state,
                mode: action.mode,
                project: action.project
            }
        case "ADD_PROJECT":
            return {
                ...state,
                projects: [...state.projects, action.project],
            };
        case "UPDATE_PROJECT":
            return {
                ...state,
                projects: state.projects.map((project) => project.id === action.project.projectid ? action.project : project
                ),
            };
        case "REMOVE_PROJECT":
            return {
                ...state,
                projects: state.projects.filter((project) => project.id !== action.projectid),
            };
        case "ADD_ASSET":
            return {
                ...state,
                project: {
                    ...state.project,
                    assets: [...state.project.assets, action.asset]
                }
            };
        case "UPDATE_ASSET":
            return {
                ...state,
                project: {
                    ...state.project,
                    assets: state.project.assets.map(asset =>
                        asset.id === action.asset.id ? action.asset : asset
                    )
                }
            };
        case "REMOVE_ASSET":
            return {
                ...state,
                project: {
                    ...state.project,
                    assets: state.project.assets.filter(asset => asset.id !== action.assetid)
                }
            };
        case "ADD_PAYSLIP":
            return {
                ...state,
                project: {
                    ...state.project,
                    payslips: [...state.project.payslips, action.payslip]
                }
            };
        case "UPDATE_PAYSLIP":
            return {
                ...state,
                project: {
                    ...state.project,
                    payslips: state.project.payslips.map(ps =>
                        ps.id === action.payslip.id ? action.payslip : ps
                    )
                }
            };
        case "REMOVE_PAYSLIP":
            return {
                ...state,
                project: {
                    ...state.project,
                    payslips: state.project.payslips.filter(ps => ps.id !== action.payslipid)
                }
            };
        case "ADD_STAFF":
            return {
                ...state,
                project: {
                    ...state.project,
                    staff: action.staff
                }
            };
        case "ADD_STAFFMEMBER":
            return {
                ...state,
                project: {
                    ...state.project,
                    staff: [...state.project.staff, action.staffmember]
                }
            };
        case "UPDATE_STAFFMEMBER":
            return {
                ...state,
                project: {
                    ...state.project,
                    staff: state.project.staff.map(staffmember =>
                        staffmember.id === action.staffmember.id ? action.staffmember : staffmember
                    )
                }
            };
        case "REMOVE_STAFFMEMBER":
            return {
                ...state,
                project: {
                    ...state.project,
                    staff: state.project.staff.filter(staffmember => staffmember.id !== action.staffmemberid)
                }
            };
        case "ADD_CURRENCY":
            return {
                ...state,
                project: {
                    ...state.project,
                    currencies: [...state.project.currencies, action.currency]
                }
            };
        case "UPDATE_CURRENCY":
            return {
                ...state,
                project: {
                    ...state.project,
                    currencies: state.project.currencies.map(item =>
                        item.id === action.currency.id ? { ...item, ...action.currency } : item
                    )
                }
            };
        case "REMOVE_CURRENCY":
            return {
                ...state,
                project: {
                    ...state.project,
                    currencies: state.project.currencies.filter(item => item.id !== action.currencyid)
                }
            };
        case "MAKE_DEFAULT_CURRENCY":
            return {
                ...state,
                project: {
                    ...state.project,
                    basecurrency: action.currencyid
                }
            };
        case "ADD_TAX":
            return {
                ...state,
                project: {
                    ...state.project,
                    taxes: [...state.project.taxes, action.tax]
                }
            };
        case "UPDATE_TAX":
            return {
                ...state,
                project: {
                    ...state.project,
                    taxes: state.project.taxes.map(item =>
                        item.id === action.tax.id ? { ...item, ...action.tax } : item
                    )
                }
            };
        case "REMOVE_TAX":
            return {
                ...state,
                project: {
                    ...state.project,
                    taxes: state.project.taxes.filter(item => item.id !== action.taxid)
                }
            };
        case "ADD_ITEM":
            return {
                ...state,
                project: {
                    ...state.project,
                    items: [...state.project.items, action.item]
                }
            };
        case "UPDATE_ITEM":
            return {
                ...state,
                project: {
                    ...state.project,
                    items: state.project.items.map(item =>
                        item.id === action.item.id ? action.item : item
                    )
                }
            };
        case "REMOVE_ITEM":
            return {
                ...state,
                project: {
                    ...state.project,
                    items: state.project.items.filter(item => item.id !== action.itemid)
                }
            };
        case "ADD_CATEGORY":
            return {
                ...state,
                project: {
                    ...state.project,
                    itemscategories: [...state.project.itemscategories, action.itemcategory]
                }
            };
        case "UPDATE_CATEGORY":
            return {
                ...state,
                project: {
                    ...state.project,
                    itemscategories: state.project.itemscategories.map(item =>
                        item.id === action.itemcategory.id ? action.itemcategory : item
                    )
                }
            };
        case "REMOVECATEGORY":
            return {
                ...state,
                project: {
                    ...state.project,
                    itemscategories: state.project.itemscategories.filter(item => item.id !== action.itemcategoryid)
                }
            };
        case "ADD_MODIFIER":
            return {
                ...state,
                project: {
                    ...state.project,
                    itemsmodifiers: [...state.project.itemsmodifiers, action.itemmodifier]
                }
            };
        case "UPDATE_MODIFIER":
            return {
                ...state,
                project: {
                    ...state.project,
                    itemsmodifiers: state.project.itemsmodifiers.map(item =>
                        item.id === action.itemmodifier.id ? action.itemmodifier : item
                    )
                }
            };
        case "REMOVEMODIFIER":
            return {
                ...state,
                project: {
                    ...state.project,
                    itemsmodifiers: state.project.itemsmodifiers.filter(item => item.id !== action.itemmodifierid)
                }
            };
        case "ADD_JOURNALENTRY":
            return {
                ...state,
                project: {
                    ...state.project,
                    journalentries: [...state.project.journalentries, action.journalentry]
                }
            };
        case "UPDATE_JOURNALENTRY":
            return {
                ...state,
                project: {
                    ...state.project,
                    journalentries: state.project.journalentries.map(journal =>
                        journal.id === action.journalentry.id ? action.journalentry : journal
                    )
                }
            };
        case "REMOVE_JOURNALENTRY":
            return {
                ...state,
                project: {
                    ...state.project,
                    journalentries: state.project.journalentries.filter(journal => journal.id !== action.id)
                }
            };
        case "ADD_CASHACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    cashaccounts: [...state.project.cashaccounts, action.cashaccount]
                }
            };
        case "UPDATE_CASHACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    cashaccounts: state.project.cashaccounts.map(item =>
                        item.id === action.cashaccount.id ? { ...item, ...action.cashaccount } : item
                    )
                }
            };
        case "REMOVE_CASHACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    cashaccounts: state.project.cashaccounts.filter(item => item.id !== action.cashaccountid)
                }
            };
        case "ADD_CLIENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    clients: [...state.project.clients, action.client]
                }
            };
        case "UPDATE_CLIENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    clients: state.project.clients.map(client =>
                        client.id === action.client.id ? action.client : client
                    )
                }
            };
        case "REMOVE_CLIENT":
            return {
                ...state,
                project: {
                    ...state.project,
                    clients: state.project.clients.filter(client => client.id !== action.id)
                }
            };
        case "ADD_SUPPLIER":
            return {
                ...state,
                project: {
                    ...state.project,
                    suppliers: [...state.project.suppliers, action.supplier]
                }
            };
        case "UPDATE_SUPPLIER":
            return {
                ...state,
                project: {
                    ...state.project,
                    suppliers: state.project.suppliers.map(supplier =>
                        supplier.id === action.supplier.id ? action.supplier : supplier
                    )
                }
            };
        case "REMOVE_SUPPLIER":
            return {
                ...state,
                project: {
                    ...state.project,
                    suppliers: state.project.suppliers.filter(supplier => supplier.id !== action.supplierid)
                }
            };
        case "ADD_SALESINVOICE":
            return {
                ...state,
                project: {
                    ...state.project,
                    salesinvoices: [...state.project.salesinvoices, action.salesinvoice]
                }
            };
        case "UPDATE_SALESINVOICE":
            return {
                ...state,
                project: {
                    ...state.project,
                    salesinvoices: state.project.salesinvoices.map(invoice =>
                        invoice.id === action.salesinvoice.id ? action.salesinvoice : invoice
                    )
                }
            };
        case "REMOVE_SALESINVOICE":
            return {
                ...state,
                project: {
                    ...state.project,
                    salesinvoices: state.project.salesinvoices.filter(invoice => invoice.id !== action.salesinvoiceid)
                }
            };
        case "ADD_TRANSACTION":
            return {
                ...state,
                project: {
                    ...state.project,
                    transactions: [...state.project.transactions, action.transaction]
                }
            };
        case "UPDATE_TRANSACTION":
            return {
                ...state,
                project: {
                    ...state.project,
                    transactions: state.project.transactions.map(transaction =>
                        transaction.id === action.transaction.id ? action.transaction : transaction
                    )
                }
            };
        case "REMOVE_TRANSACTION":
            return {
                ...state,
                project: {
                    ...state.project,
                    transactions: state.project.transactions.filter(transaction => transaction.id !== action.id)
                }
            };
        case "ADD_INTERACCOUNTTRANSFER":
            return {
                ...state,
                project: {
                    ...state.project,
                    interaccounttransfers: [...state.project.interaccounttransfers, action.interaccounttransfer]
                }
            };
        case "UPDATE_INTERACCOUNTTRANSFER":
            return {
                ...state,
                project: {
                    ...state.project,
                    interaccounttransfers: state.project.interaccounttransfers.map(interaccounttransfer =>
                        interaccounttransfer.id === action.interaccounttransfer.id ? action.interaccounttransfer : interaccounttransfer
                    )
                }
            };
        case "REMOVE_INTERACCOUNTTRANSFER":
            return {
                ...state,
                project: {
                    ...state.project,
                    interaccounttransfers: state.project.interaccounttransfers.filter(interaccounttransfer => interaccounttransfer.id !== action.interaccounttransferid)
                }
            };
        case "ADD_PURCHASEINVOICE":
            return {
                ...state,
                project: {
                    ...state.project,
                    purchaseinvoices: [...state.project.purchaseinvoices, action.purchaseinvoice]
                }
            };
        case "UPDATE_PURCHASEINVOICE":
            return {
                ...state,
                project: {
                    ...state.project,
                    purchaseinvoices: state.project.purchaseinvoices.map(invoice =>
                        invoice.id === action.purchaseinvoice.id ? action.purchaseinvoice : invoice
                    )
                }
            };
        case "REMOVE_PURCHASEINVOICE":
            return {
                ...state,
                project: {
                    ...state.project,
                    purchaseinvoices: state.project.purchaseinvoices.filter(invoice => invoice.id !== action.purchaseinvoiceid)
                }
            };
        case "ADD_PRODUCTIONORDER":
            return {
                ...state,
                project: {
                    ...state.project,
                    productionorders: [...state.project.productionorders, action.productionorder]
                }
            };
        case "UPDATE_PRODUCTIONORDER":
            return {
                ...state,
                project: {
                    ...state.project,
                    productionorders: state.project.productionorders.map(order =>
                        order.id === action.productionorder.id ? action.productionorder : order
                    )
                }
            };
        case "REMOVE_PRODUCTIONORDER":
            return {
                ...state,
                project: {
                    ...state.project,
                    productionorders: state.project.productionorders.filter(order => order.id !== action.productionorderid)
                }
            };
        case "ADD_QUOTATION":
            return {
                ...state,
                project: {
                    ...state.project,
                    quotations: [...state.project.quotations, action.quotation]
                }
            };
        case "UPDATE_QUOTATIONS":
            return {
                ...state,
                project: {
                    ...state.project,
                    quotations: state.project.quotations.map(quote =>
                        quote.id === action.quote.id ? action.quote : quote
                    )
                }
            };
        case "REMOVE_QUOTATION":
            return {
                ...state,
                project: {
                    ...state.project,
                    quotations: state.project.quotations.filter(quote => quote.id !== action.quotationid)
                }
            };
        case "ADD_PROJECTDETAILS":
            return {
                ...state,
                project: {
                    ...state.project,
                    projectdetails: action.projectdetails,
                    projectdetailsimage: action.projectdetailsimage
                }
            };
        case "REMOVE_PROJECTDETAILSIMAGE":
            return {
                ...state,
                project: {
                    ...state.project,
                    projectdetailsimage: ''
                }
            };
        case "ADD_STARTDATE":
            return {
                ...state,
                project: {
                    ...state.project,
                    startdate: action.startdate
                }
            };
        case "ADD_ACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    [action.accounttype]: [
                        ...(state.project[action.accounttype] || []),
                        action.account
                    ]
                }
            };
        case "UPDATE_ACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    [action.accounttype]: (state.project[action.accounttype] || []).map(account =>
                        account.id === action.account.id ? action.account : account
                    )
                }
            };
        case "REMOVE_ACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    [action.accounttype]: (state.project[action.accounttype] || []).filter(
                        account => account.id !== action.id
                    )
                }
            };
        case "ADD_GROUP":
            return {
                ...state,
                project: {
                    ...state.project,
                    [action.grouptype]: [
                        ...(state.project[action.grouptype] || []),
                        action.group
                    ]
                }
            };
        case "UPDATE_GROUP":
            return {
                ...state,
                project: {
                    ...state.project,
                    [action.grouptype]: (state.project[action.grouptype] || []).map(group =>
                        group.id === action.group.id ? action.group : group
                    )
                }
            };
        case "REMOVE_GROUP":
            return {
                ...state,
                project: {
                    ...state.project,
                    [action.grouptype]: (state.project[action.grouptype] || []).filter(
                        group => group.id !== action.id
                    )
                }
            };
        case "ADD_EXCHANGERATE":
            return {
                ...state,
                project: {
                    ...state.project,
                    exchangerates: [...state.project.exchangerates, action.exchangerate]
                }
            };
        case "UPDATE_EXCHANGERATE":
            return {
                ...state,
                project: {
                    ...state.project,
                    exchangerates: state.project.exchangerates.map(rate =>
                        rate.id === action.exchangerate.id ? action.exchangerate : rate
                    )
                }
            };
        case "REMOVE_EXCHANGERATE":
            return {
                ...state,
                project: {
                    ...state.project,
                    exchangerates: state.project.exchangerates.filter(rate => rate.id !== action.exchangerateid)
                }
            };
        case "ADD_SUBACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    subaccounts: [...state.project.subaccounts, action.subaccount]
                }
            };
        case "UPDATE_SUBACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    subaccounts: state.project.subaccounts.map(subaccount =>
                        subaccount.id === action.subaccount.id ? action.subaccount : subaccount
                    )
                }
            };
        case "REMOVE_SUBACCOUNT":
            return {
                ...state,
                project: {
                    ...state.project,
                    subaccounts: state.project.subaccounts.filter(subaccount => subaccount.id !== action.subaccountid)
                }
            };
        case "ADD_RECONCILIATION":
            return {
                ...state,
                project: {
                    ...state.project,
                    reconciliations: [...state.project.reconciliations, action.reconciliation]
                }
            };
        case "UPDATE_RECONCILIATION":
            return {
                ...state,
                project: {
                    ...state.project,
                    reconciliations: state.project.reconciliations.map(reconciliation =>
                        reconciliation.id === action.reconciliation.id ? action.reconciliation : reconciliation
                    )
                }
            };
        case "REMOVE_RECONCILIATION":
            return {
                ...state,
                project: {
                    ...state.project,
                    reconciliations: state.project.reconciliations.filter(reconciliation => reconciliation.id !== action.reconciliationid)
                }
            };
        case "IMPORT_SALESINVOICES":
            return {
                ...state,
                project: {
                    ...state.project,
                    salesinvoices: [...state.project.salesinvoices, ...action.salesinvoices]
                }
            };
        case "IMPORT_ASSETS":
            return {
                ...state,
                project: {
                    ...state.project,
                    assets: [...state.project.assets, ...action.assets]
                }
            };
        case "IMPORT_STAFF":
            return {
                ...state,
                project: {
                    ...state.project,
                    staff: [...state.project.staff, ...action.staff]
                }
            };
        case "IMPORT_ITEMS":
            return {
                ...state,
                project: {
                    ...state.project,
                    items: [...state.project.items, ...action.items]
                }
            };
        case "IMPORT_CHARTACCOUNTS":
            return {
                ...state,
                project: {
                    ...state.project,
                    incomegroups: [...state.project.incomegroups, ...action.incomegroups],
                    incomeaccounts: [...state.project.incomeaccounts, ...action.incomeaccounts],
                    expensegroups: [...state.project.expensegroups, ...action.expensegroups],
                    expenseaccounts: [...state.project.expenseaccounts, ...action.expenseaccounts]
                }
            };
        case "IMPORT_CURRENCIES":
            return {
                ...state,
                project: {
                    ...state.project,
                    currencies: [...state.project.currencies, ...action.currencies]
                }
            };
        case "IMPORT_TEMPLATES":
            return {
                ...state,
                project: {
                    ...state.project,
                    templates: [...state.project.templates, ...action.templates]
                }
            };
        default:
            return state
    }
}

export default reducer;